publishingApp.service('exceptionHandler', [ '$injector', function($injector) {
    // service object
    var service = {
        error: function () {
            self.type = 'error';
            log.apply(self, arguments);
        },
        warn: function () {
            self.type = 'warn';
            log.apply(self, arguments);
        },
        info: function () {
            self.type = 'info';
            log.apply(self, arguments);
        },
        log: function () {
            self.type = 'log';
            log.apply(self, arguments);
        },
        enabled: false,
        logs: [],
        network: []
    };

    var log = function () {
        // define args array
        args = [];
        // loop through arguments and prepare data
        if (typeof arguments === 'object') {
            for (var i = 0; i < arguments.length; i++) {
                arg = arguments[i];
                var exception = {}; // create new exception
                exception.message = arg.message; // get message
                exception.stack = arg.stack; // get error trace
                args.push(JSON.stringify(exception));
            }
        }

        var eventLogDateTime = new Date().toLocaleString(); // when it happened
        var logItem = {
            time: eventLogDateTime, // time
            url: window.location.href,
            message: args.join(' '), // message
            type: type // type error, log, warn or info
        };

        // push logItem to service object logs array
        service.logs.push(logItem);
    };

    return service;
}]);